import React, { useRef } from "react";
import "../../Style/Slider/TripSlider.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import PlaceSharpIcon from "@mui/icons-material/PlaceSharp";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import AccessTimeSharpIcon from "@mui/icons-material/AccessTimeSharp";
import ArrowBackIosNewSharpIcon from "@mui/icons-material/ArrowBackIosNewSharp";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../Style/CategoryListPage/Category.css";
const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://highmountains.in";  // replace with your production backend URL

const TripSlider = ({ trips }) => {
  const navigate = useNavigate();
  const arrowRef = useRef();

 var settings = {
  dots: false,
  infinite: true,        // ✅ change false → true
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipe: true,
  touchMove: true,
  autoplay: true,
  autoplaySpeed: 2000,   // ✅ add this if missing
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
        centerMode: false,
      },
    },
  ],
};

  return (
    <div className="slider__trip Mon_font">
      <Slider ref={arrowRef} {...settings}>
        {trips?.map((trip, index) => {

          return (
            <div
              key={index}
              className="trip-container"
              onClick={() =>
                navigate(`/trip/${trip?.heading.replace(/\s+/g, "-")}`)
              }
            >
<div className="trip category-page-trip">
                {/* Customised Label */}
                {trip?.customised === "true" && (
                  <div className="customise-label">Customised</div>
                )}

                <div className="trip-badges">
                  {/* Price */}
                  <div className="trip-price">
                    <small>Starts From </small>
                    <b>
                      ₹{" "}
                      {(() => {
                        const getMinPrice = (arr) => {
                          if (!Array.isArray(arr)) return 0;
                          let minPrice = Infinity;
                          arr.forEach((costing) => {
                            const heading = costing?.heading?.toLowerCase() || "";
                            if (heading.includes("add on")) return;
                            if (Array.isArray(costing.package)) {
                              costing.package.forEach((pkg) => {
                                const price = parseInt(pkg?.price);
                                if (!isNaN(price) && price < minPrice) {
                                  minPrice = price;
                                }
                              });
                            }
                          });
                          return isFinite(minPrice)
                            ? minPrice.toLocaleString("en-US")
                            : "0";
                        };
                        const price =
                          trip?.customised === "true"
                            ? getMinPrice(trip.hmCosting)
                            : getMinPrice(trip.costing);
                        return price;
                      })()}
                    </b>
                  </div>

                  {/* Spots Left - only for non-customised trips */}
                  {trip?.customised === "false" && (
                    <div
                      className={`spots-left ${
                        Number(trip.spotsLeft) > 0
                          ? "spots-available"
                          : "spots-soldout"
                      }`}
                    >
                      {Number(trip.spotsLeft) > 0
                        ? `${trip.spotsLeft} Spot${
                            trip.spotsLeft > 1 ? "s" : ""
                          } Left`
                        : "Sold Out"}
                    </div>
                  )}
                </div>

                {/* Trip Image */}
          <img
  src={`https://highmountains.in/tripimage/${trip?.image}`}
  alt={trip?.heading || "Trip Image"}
/>


                {/* Heading */}
                <h5 className="mb-3">{trip?.heading}</h5>

                {/* Trip Details */}
                <div className="trip-det">
                  <p>
                    <PlaceSharpIcon className="icon me-1" />
                    {trip?.departure}
                  </p>
                  <p className="justify-content-end">
                    <AccessTimeSharpIcon className="icon me-1" />
                    {trip?.duration}
                  </p>

                  <div className="w-100 d-flex mb-3">
                    {trip?.customised === "false" && (
                      <CalendarMonthSharpIcon className="icon me-1" />
                    )}
                    {trip?.customised === "false" ? (
                      trip?.dates.slice(0, 3).map((item, index, array) => (
                        <span
                          key={index}
                          className={`${index !== 0 && "ms-2"}`}
                        >
                          <small>
                            {new Date(item.date).toLocaleString("default", {
                              day: "numeric",
                              month: "short",
                            })}
                          </small>
                          {index < array.length - 1 && <span>,</span>}
                        </span>
                      ))
                    ) : (
                      <div>
                        <CalendarMonthSharpIcon className="icon me-1" />
                        <small>Best Time - {trip?.bestTime}</small>
                      </div>
                    )}
                  </div>
                </div>

                <button className="w-100">View Details</button>
              </div>
            </div>
          );
        })}
      </Slider>

      {/* Slider Navigation Arrows */}
      <div className="slider-btns">
        <div onClick={() => arrowRef.current.slickPrev()}>
          <ArrowBackIosNewSharpIcon className="icon slider-left" />
        </div>
        <div onClick={() => arrowRef.current.slickNext()}>
          <ArrowForwardIosSharpIcon className="slider-right" />
        </div>
      </div>
    </div>
  );
};

export default TripSlider;
